// extracted by mini-css-extract-plugin
export var projects = "projects-module--projects--RoR2i";
export var fadeIn = "projects-module--fade-in--3vlZY";
export var projectsContainer = "projects-module--projectsContainer--Rg-Gu";